import './Styles/ScrollUpArrowStyles.css'

import { useState, useEffect } from 'react'
import { FaArrowAltCircleUp, FaArrowAltCircleDown } from "react-icons/fa"
import { useParams } from '../../Providers/ParamsProvider'

/**
 * DK : Komponent przewijania góra - dół 
 * @param {*} color - kolor strzałek, domyślnie 'var(--primary)'
 * @returns 
 */
const ScrollUpArrow = ({ color = 'var(--primary)' }) => {
    const { isMobile } = useParams()
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop
            if (scrollTop > 300) {
                setIsVisible(true)
            } else {
                setIsVisible(false)
            }
        }
        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }

    const scrollToBottom = () => {
        window.scrollTo({
            top: document.documentElement.scrollHeight,
            behavior: 'smooth',
        })
    }

    let arrowType = isMobile ? 'scroll-up-arrow-mobile' : 'scroll-up-arrow'
    let arrowStyle = isVisible ? `${arrowType}` : 'collapse'
    let colorStyle = color

    return (
        <div className={`${arrowStyle} `}>
            <FaArrowAltCircleUp
                size={isMobile ? 35 : 45}
                onClick={() => scrollToTop()}
                color={colorStyle}
            />
            <FaArrowAltCircleDown
                className={isMobile ? 'mt-1' : 'mt-3'}
                size={isMobile ? 35 : 45}
                onClick={() => scrollToBottom()}
                color={colorStyle}
            />
        </div>
    )
}

export default ScrollUpArrow